import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import merge from 'lodash/merge';
import Button from '../Button.js';
import { stringifyFacets } from '../../../utils/products.js';
import { setCurentFacetsQuery } from '../../../actions/shared/facets';
import productsUtil from '../../../utils/products.js';
import { generateEvent } from '../../../utils/dataGrinch';
import luxeScreen from '../../../refresh/constants/luxeScreenType';
import { gtmEventPush } from '../../../modules/ga/GTMdatalayer';
import properties from './../../../modules/ajio-util/properties';
/**
 * Component is used for showing breadcrumb in desktop above product list
 */

class AppliedFilters extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showAdditionalFilterContent: false,
      showButton: false,
      rowHeight: 0
    };
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      filterVisible = { clientHeight: 0 },
      appliedFilterWrapper = { clientHeight: 0 }
    } = this.refs;
    let showButton;

    if (appliedFilterWrapper.clientHeight && this.state.rowHeight === 0) {
      this.state.rowHeight = appliedFilterWrapper.clientHeight;
    }

    if (filterVisible.clientHeight > this.state.rowHeight) {
      showButton = true;
    } else {
      showButton = false;
    }

    if (
      prevState.showButton !== showButton &&
      prevState.showAdditionalFilterContent === this.state.showAdditionalFilterContent
    ) {
      let newStateObj = {
        showButton
      };
      if (!showButton) {
        newStateObj.showAdditionalFilterContent = false;
      }
      this.setState(newStateObj);
    }
  }

  /**
   * Get query from Facets store or set it into empty {}.
   */

  getFacetsQuery() {
    const { facetsQuery } = this.props;
    return merge({}, facetsQuery);
  }

  /**
   * Iterate over facetObject and create list of breadcrumb for facets.
   */

  getSelectedFacetsInfo = () => {
    const { facetsQuery = {}, request = {} } = this.props;
    let path = request.browserPath || request.pathname || '';
    let curatedAppliedFacets = [];
    if (path.includes('/s/')) {
      let { curatedQuery: { facets: curatedFacets = '' } = {} } = request;
      let currentCuratedObj = productsUtil.parseFacets(curatedFacets);

      curatedAppliedFacets = Object.keys(currentCuratedObj).reduce((acc, facetId) => {
        let facetItems = currentCuratedObj[facetId] || [];
        facetItems.forEach(facetItemId => {
          acc.push(facetItemId);
        });
        return acc;
      }, []);
    }

    return Object.keys(facetsQuery).reduce(
      (acc, facetId) => {
        const facetItems = facetsQuery[facetId] || [];
        facetItems.forEach(facetItemId => {
          let label = facetItemId;
          if (facetId == 'price') {
            label = `Rs.${label.replace(',', ' - Rs.')}`;
          } else if (facetId == 'exactdiscount') {
            label = `${label.replace(',', '% - ')}%`;
          }
          if (path.includes('/s/')) {
            if (!curatedAppliedFacets.includes(facetItemId)) {
              acc.facets.push({ code: facetItemId, label, facetId });
              acc.allFacetsLabelLength += label ? label.length : 0;
            }
          } else {
            acc.facets.push({ code: facetItemId, label, facetId });
            acc.allFacetsLabelLength += label ? label.length : 0;
          }
        });
        return acc;
      },
      { facets: [], allFacetsLabelLength: 0 }
    );
  };

  toggleAdditionalFilterContent = () => {
    const { showAdditionalFilterContent = false } = this.state;
    this.setState({
      showAdditionalFilterContent: !showAdditionalFilterContent
    });
  };

  isFilterDisabled = (facetId, code) => {
    const { plpGender, facetsQuery } = this.props;
    // if (facetId === 'genderfilter' && plpGender) {
    //   const genderFilters = facetsQuery.genderfilter || [];
    //   return genderFilters.length === 1 && 
    //          genderFilters[0].toLowerCase() === plpGender.toLowerCase();
    // }
    if (facetId === 'genderfilter' && plpGender && plpGender.toLowerCase() != "general") {
      return true;
    }
    return false;
  };

  render() {
    const newDesignLuxe = this.props.newDesignLuxe;
    const imageBaseUrl = properties.getProperty('imageBaseUrl');
    const { showAdditionalFilterContent = false } = this.state;
    /**
     * allFacetLabelLength -> Sum of character for all the label shown in breadcrumb
     *  "facets" key is renamed as "breadcrumbList". Since these values are derived from left pane
     *  i.e list of facets (filters)
     */
    let { facets: breadcrumbList, allFacetsLabelLength = 0 } = this.getSelectedFacetsInfo();
    const { plp: { screenType = '', screenName = '' } = {} } = luxeScreen;
    breadcrumbList = breadcrumbList.filter(
      el => el.label && el.label !== 'null' && el.label !== 'undefined'
    );
    if (breadcrumbList.length == 0) {
      return null;
    }
    return (
      <div id="breadcrumb-container">
        <div
          className={`fnl-plp-appliedFliters ${showAdditionalFilterContent ? 'show-more' : ''}`}
          ref="appliedFilterWrapper"
        >
          {this.state.showButton ? (
            <Button
              className="fnl-plp-appliedFliters-more"
              onClick={this.toggleAdditionalFilterContent}
            >
              <span className="fnl-plp-appliedFliters-more-label">
                {showAdditionalFilterContent ? 'Less' : 'Show all'}
              </span>
              <i className={showAdditionalFilterContent ? 'ic-angle-up' : 'ic-angle-down'} />
            </Button>
          ) : null}
          <div className="fnl-plp-filtervisible" ref="filterVisible">
            {breadcrumbList.map((item, key) => {
              let { code, label, facetId } = item;
              // const isDisabled = this.isFilterDisabled(facetId, code);
              return (
                <div key={`afilter-${key}`} className="fnl-plp-afliter">
                  <span className="pull-left">{label}</span>
                  {/* {!isDisabled && ( */}
                    <a
                  aria-label={`Remove filter - ${label}`}
                  role='button'
                    tabIndex={0}
                      onClick={e => {
                        /**
                         * Reading array from facet.query inside store.
                         * ["l1l3nestedCategory"]
                         */
                        const facetsQuery = this.getFacetsQuery();
                        if (newDesignLuxe) {
                          gtmEventPush({
                            event: 'plp_filter_remove',
                            event_category: 'product list interactions',
                            event_action: 'filter remove individual',
                            event_label: label,
                            store_type: 'luxe',
                            screen_name: screenName,
                            screen_type: screenType
                          });
                        } else {
                          generateEvent({
                            Event: 'Filter',
                            value: {
                              'ListOfFilters:': facetsQuery
                            }
                          });
                        }

                        if (facetsQuery[facetId] && facetsQuery[facetId].includes(code)) {
                          facetsQuery[facetId].splice(facetsQuery[facetId].indexOf(code), 1);
                          this.props.setCurentFacetsQuery(facetsQuery);
                          this.props.pushToHistory({
                            facets: stringifyFacets(facetsQuery),
                            currentPage: 0
                          });
                        }
                        return e.preventDefault();
                      }}
                    >
                    <span
                      className="closeBtn remove filterClose"
                      style={{
                        backgroundImage: !newDesignLuxe
                          ? `url(${`${imageBaseUrl}/static/img/filter-cross-icon.svg`})`
                          : null
                    }}
                    />
                  </a>
                {/* )} */}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { facets = {}, request = {} } = state;
  const { currentFacets = {}, plpGender = "" } = facets;
  const { query: facetsQuery = {} } = currentFacets;
  return {
    facetsQuery,
    request,
    plpGender
  };
};

function mapDispatchToProps(dispatch) {
  return {
    setCurentFacetsQuery: query => {
      dispatch(setCurentFacetsQuery(query));
    }
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AppliedFilters));
